const messages = {
    title: "INFORMATION PRODUIT",
    description:
        "Téléchargez ici les dernières brochures et flyers de nos pneus Bridgestone et Firestone.",
    brochureCategories: {
    products: "Produits",
    brand_and_solutions: "Marque et Solutions",
    season_and_promotions: "Saison & Promotions",
    format: "Format",
    cars_and_vans: "Voiture Particulière & Utilitaire",
    summer: "Été",
    winter: "Hiver",
    promotions: "Promotions",
    all_season: "Toutes saisons",
    truck_and_buses: "Poids lourds & Bus",
    motorcycle: "Moto",
    agriculture: "Agriculture",
    construction_machinery: "Engins de construction",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Matériaux",
    brochures: "Brochures produits",
    price_list: "Listes de prix",
    materials: "Matériaux",
    video_in_store: "Vidéo avec sous-titres",
    video_online: "Vidéo sans sous-titres",
    banner_website: "Bannière",
    banner_social_media: "Réseaux sociaux",
    logos: "Logos",
  },
  searchMedia: "Saisir un élément de recherche",
  searchResults: "Résultats de recherche",
};

export default {
  messages,
};
